import { translate } from "@/helper/translate";

export type ScanMode =
    | "contentQuality"
    | "atsCompatibility"
    | "writingAndLanguage"
    | "formatAndDesign";

export interface IFeedbackItem {
    message: string;
    type: "positive" | "negative" | "neutral";
}

export type Priority = "high" | "medium" | "low";

export const ScanKeysLabels = {
    contentQuality: "Content Quality",
    atsCompatibility: "ATS Compatibility",
    writingAndLanguage: "Writing & Language",
    formatAndDesign: "Format & Design",
    work_experience: "Work Experience",
    skills: "Skills Alignment",
    summary: "Summary",
    readability: "Visual Hierarchy",
    consistency: "Formatting Consistency",
    length_whitespace: "Length & Spacing",
    writing_mechanics: "Grammer & Spelling",
    action_tone: "Action Tone",
    clarity_conciseness: "Clarity & Conciseness",
    keyword_optimization: `Keywords ${translate("optimisation", "title")}`,
    format_structure: "Format & Structure",
    required_sections: "Recommended Sections",
    quantified_results: "Quantified Results",
};

export interface IScanResultItem {
    score: number;
    max_score: number;
    feedback: IFeedbackItem[];
    priority: Priority;
}

export interface IScanResults {
    contentQuality?: {
        [sectionKey: string]: IScanResultItem;
    };
    atsCompatibility?: {
        [sectionKey: string]: IScanResultItem;
    };
    writingAndLanguage?: {
        [sectionKey: string]: IScanResultItem;
    };
    formatAndDesign?: {
        [sectionKey: string]: IScanResultItem;
    };
}

export interface IAtsScanResult {
    userId: string;
    resumeId: string;
    tenantId: string;
    scanModes: ScanMode[];
    scanResults: IScanResults;
    score: number;
    createdAt: Date;
    updatedAt: Date;
}
